import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index';

Vue.use(VueRouter)

const router = new VueRouter({
    mode: "history",
    routes: [
        // 초기 진입 페이지
        { path: '/', redirect: '/login' },
        
        // 없는 페이지
        { path: '*', component: () => import('@/components/common/NotFoundPage.vue') },
        
        // 본인인증 페이지
        { path: '/nice', name: 'nice', component: () => import('@/views/Nice.vue') },
        { path: '/niceGuide', name: 'niceGuide', component: () => import('@/views/join/NiceGuide.vue') },
        { path: '/niceComplete', name: 'niceComplete', component: () => import('@/views/join/NiceComplete.vue') },

        // start
        { path: '/start', name: 'start', component: () => import('@/views/start/Start.vue') },

        // join
        { path: '/qrCode', name: 'qrCode', component: () => import('@/views/join/QrCode.vue'), meta: { auth: true },  },
        { path: '/agree', name: 'agree', component: () => import('@/views/join/Agree.vue') },
        { path: '/certification', name: 'certification', component: () => import('@/views/join/Certification.vue') },
        { path: '/certificationComplete', name: 'certificationComplete', component: () => import('@/views/join/CertificationComplete.vue') },
        { path: '/enterInfo', name: 'enterInfo', component: () => import('@/views/join/EnterInfo.vue') },

        // terms
        { path: '/terms', name: 'terms', component: () => import('@/views/terms/Terms.vue') },
        { path: '/privacyConsent', name: 'privacyConsent', component: () => import('@/views/terms/PrivacyConsent.vue') },
        { path: '/locationServiceTerms', name: 'locationServiceTerms', component: () => import('@/views/terms/LocationServiceTerms.vue') },
        { path: '/locationAlertTerms', name: 'locationAlertTerms', component: () => import('@/views/terms/LocationAlertTerms.vue') },
        { path: '/userDataSharingConsent', name: 'userDataSharingConsent', component: () => import('@/views/terms/UserDataSharingConsent.vue') },

        // setting
        { path: '/locationSet', name: 'locationSet', component: () => import('@/views/setting/LocationSet.vue') },
        { path: '/alarmSet', name: 'alarmSet', component: () => import('@/views/setting/AlarmSet.vue') },
        { path: '/markSet', name: 'markSet', component: () => import('@/views/setting/MarkSet.vue') },
        { path: '/connectionComplete', name: 'connectionComplete', component: () => import('@/views/setting/ConnectionComplete.vue') },
        { path: '/setting', name: 'setting', component: () => import('@/views/setting/Setting.vue'), meta: { auth: true }, },
        { path: '/myInfo', name: 'myInfo', component: () => import('@/views/setting/MyInfo.vue'), meta: { auth: true }, },
        { path: '/withdraw', name: 'withdraw', component: () => import('@/views/setting/Withdraw.vue'), meta: { auth: true }, },

        // login
        { path: '/login', name: 'login', component: () => import('@/views/login/Login.vue') },
        { path: '/findEmailComplete', name: 'findEmailComplete', component: () => import('@/views/login/FindEmailComplete.vue') },
        { path: '/findPw', name: 'findPw', component: () => import('@/views/login/FindPw.vue') },
        { path: '/findPwComplete', name: 'findPwComplete', component: () => import('@/views/login/FindPwComplete.vue') },

        // home
        { path: '/home', name: 'home', component: () => import('@/views/home/Home.vue'), meta: { auth: true }, },
        { path: '/pwSet', name: 'pwSet', component: () => import('@/views/home/PwSet.vue'), meta: { auth: true }, },
        { path: '/alarm', name: 'alarm', component: () => import('@/views/home/Alarm.vue'), meta: { auth: true }, }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.auth && !store.getters.isLogin) {
      console.log('인증이 필요합니다');
      next('/login');
      return;
    }
    next();
  });
  
  export default router;